<template>
  <div class="content">
    <!-- <video class="background" style="
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      margin-bottom: -3px;" src="../../assets/bg-0622.mp4" autoplay loop muted></video> -->
    <div class="body">
      <div class="custom-carousel" ref="carousel">
        <div class="carousel-wrapper" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <div class="carousel-page" v-for="(group, pageIndex) in groupList" :key="pageIndex">
            <div class="group-column group-single">
              <!-- <div class="group-title">{{ group.name }}</div> -->
              <div
                class="list"
                v-for="(member, i) in group.members"
                :key="member.id || `${group.name}-${i}`"
                :style="{
                  top: listTopStart + i * memberRowHeight + '%',
                  zIndex: i,
                  height: memberRowHeight + '%'
                }"
              >
                <div class="item-inner paiming">
                  <div :class="i < 2 ? 'paiming-number' : 'paiming-number-gray'">{{ i + 1 }}</div>
                </div>
                <div class="item-inner logo">
                  <img :src="member.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
                </div>
                <div class="item">
                  <div :class="['item-inner', 'total', { 'total-page2': i >= 2 }]">
                    <div class="item-inner nickname">
                      <span>{{ member.nickname }}</span>
                    </div>
                    <div class="total-inner">
                      <span>{{ parseInt(member.total ? member.total.toFixed(0) : 0) }}分</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-indicators">
      <span
        v-for="(group, index) in groupList"
        :key="index"
        :class="{ active: currentIndex === index }"
        @click="goToPage(index)"
      >{{ index + 1 }}</span>
    </div>
    <div class="pause-con">
      <button @click="pauseClick">{{ pause ? '启动' : '暂停' }}</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'
import userList from './data-0622.js'
import axios from '../axios-instance'

const MEMBERS_PER_GROUP = 7

export default {
  name: 'pageTpPaiming',
  data () {
    return {
      groups: {},
      groupNames: ['1组', '2组', '3组', '4组', '5组', '6组', '7组', '8组'],
      personList: userList || [],
      data: [],
      touxiang: require('../../assets/touxiang.png'),
      currentIndex: 0,
      carouselInterval: null,
      pause: false,
      listTopStart: 14,
      topPosition: 100 / MEMBERS_PER_GROUP,
      interval: undefined,
      animating: false,
      dayTotal: 0
    }
  },
  computed: {
    memberRowHeight () {
      return (100 - this.listTopStart) / MEMBERS_PER_GROUP
    },
    groupMemberIds () {
      const set = new Set()
      this.groupNames.forEach(name => {
        ((this.groups || {})[name] || []).forEach(id => set.add(id))
      })
      return set
    },
    groupList () {
      return this.groupNames.map(name => {
        const memberIds = (this.groups || {})[name] || []
        // 获取实际成员并按分数降序排序
        const realMembers = memberIds
          .map(id => this.data.find(p => p.id === id))
          .filter(Boolean)
          .sort((a, b) => (b.total || 0) - (a.total || 0))

        let members = []
        if (realMembers.length === 0) {
          // 全组无实际成员，只显示一行“待定”
          members = [{ id: `empty-${name}-0`, nickname: '待定', img: '', total: 0 }]
        } else {
          // 只显示实际成员，不填充“待定”
          members = realMembers.slice(0, 4)
        }

        return { name, members }
      })
    }
  },
  mounted () {
    this.getGroupsInfo().then(() => {
      this.interval = setInterval(() => {
        this.getAllData()
      }, 20000)
      this.getAllData(true)
      this.startAutoPlay()
    })
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.carouselInterval)
  },
  methods: {
    pauseClick () {
      this.pause = !this.pause
      if (this.pause) {
        clearInterval(this.carouselInterval)
      } else {
        this.startAutoPlay()
      }
    },
    startAutoPlay () {
      this.carouselInterval = setInterval(() => {
        this.nextPage()
      }, 5000)
    },
    nextPage () {
      this.currentIndex = (this.currentIndex + 1) % this.groupList.length
    },
    goToPage (index) {
      this.currentIndex = index
    },
    getGroupsInfo () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/kv/get/groups`,
        method: 'get'
      })
        .then((res) => {
          if (res && res.data && res.data.data) {
            try {
              const parsed = JSON.parse(res.data.data)
              if (parsed && typeof parsed === 'object') {
                this.groups = parsed
              }
            } catch (e) {
              console.error('分组数据解析失败：', e)
            }
          }
        })
        .catch((e) => {
          console.error('获取分组数据失败：', e)
        })
    },
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime0622')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 9000) {
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData0622') || '{}'), isFirst)
        return false
      }
      this.getData().then((res) => {
        console.log('日志数据：', res)
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime0622', moment().valueOf())
          window.localStorage.setItem('cacheData0622', JSON.stringify(res.data.data))
          this.loaded(res.data.data, isFirst)
        } else {
          this.loaded(JSON.parse(window.localStorage.getItem('cacheData0622') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData0622') || '{}'), isFirst)
      })
    },
    getData () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/kv/get/0622data`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      }).then(res => {
        if (res.data && res.data.code === 0 && res.data.data) {
          try {
            const parsed = JSON.parse(res.data.data)
            return { data: { code: 0, data: parsed } }
          } catch (e) {
            console.error('0622data 解析失败：', e)
          }
        }
        return res
      })
    },
    loaded (data, isFirst) {
      let total = 0
      const res = cloneDeep(userList)
        // .filter((item) => this.groupMemberIds.has(item.id) && data[item.id] !== undefined)
        .map((item) => {
          item.total = data[item.id] || 0
          total += item.total
          return item
        })
      this.dayTotal = total

      if (isFirst) {
        this.data = res.map((item) => ({ ...item, total: 0 }))
      }
      this.dealData(this.data, res, isFirst)
    },
    dealData (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          item.newNumber = item.total
          const old = data.find(d => d.id === item.id)
          item.total = old ? old.total : 0
        })
      } else {
        newData.forEach((item) => {
          item.newNumber = item.total
          item.total = 0
        })
      }
      if (newData && newData.length) {
        newData.forEach((item) => {
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data = newData
      this.intervalFn(isFirst)
    },
    intervalFn (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.data = this.data.map(item => {
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    getOnce (n, o) {
      if (n !== o) {
        return (n - o) / 40
      }
      return 0
    }
  }
}
</script>

<style scoped>
.content {
  position: relative;
  width: 3000px;
  height: 1200px;
  font-size: 22px;
  background: green;
}

.body {
  position: relative;
  width: 54%;
  height: 97%;
  overflow: hidden;
  left: 23%;
  top: 0;
  padding-top: 1%;
}

.custom-carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.carousel-page {
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  position: relative;
}

.con1 {
  position: absolute;
  top: 0;
  left: 10%;
  height: 100%;
  width: 38%;
}

.con2 {
  position: absolute;
  top: 0;
  left: 52%;
  height: 100%;
  width: 38%;
}

.group-single {
  position: absolute;
  top: 24%;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  width: 80%;
}

.group-title {
  margin-left: 59%;
  transform: translateX(-50%);
  height: 6%;
  margin-bottom: 2%;
  margin-top: 2%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
  font-size: 28px;
  font-weight: bold;
  color: #e6d49a;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  border: 2px solid #e6d49a;
  border-radius: 37px;
  background: linear-gradient(135deg, rgb(61 23 102) 0%, rgb(90 24 154) 50%, rgb(123 44 191) 100%);
  box-shadow:
    0 0 8px rgba(123, 44, 191, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    0 3px 6px rgba(0, 0, 0, 0.25);
  z-index: 20;
}

.list {
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
}

.paiming {
  display: flex;
  align-items: center;
  height: calc(100% - 10px);
  color: #e6d49a;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.paiming-number {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(61 23 102) 0%, rgb(90 24 154) 50%, rgb(123 44 191) 100%);
  line-height: 34px;
  font-weight: bold;
  color: #fff;
  box-shadow:
    0 0 10px rgba(123, 44, 191, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.55);
  border: 1px solid #9a825f;
}

.paiming-number-gray {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(138 138 149) 0%, rgb(110 110 122) 50%, rgb(88 88 100) 100%);
  line-height: 34px;
  font-weight: bold;
  color: #f0f0f0;
  box-shadow:
    0 0 8px rgba(110, 110, 122, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
  border: 1px solid #6e6e7a;
}

.logo {
  display: flex;
  align-items: center;
  height: 70%;
  margin: 0 10px;
  width: auto;
  aspect-ratio: 1/1;
  position: relative;
}

.huangguan {
  position: absolute;
  top: -47%;
  left: -16%;
  height: 80%;
  width: auto;
}

.touxiang {
  width: 100%;
  height: auto;
  border: 1px solid #fff;
  border-radius: 50%;
}

.item {
  position: relative;
  color: #fff;
  width: 100%;
  height: 65%;
  display: flex;
  flex-direction: row;
}

.total {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 24px;
  width: 100%;
  text-align: right;
  justify-content: space-between;
  line-height: 18px;
  box-sizing: border-box;
  position: relative;
  border: 2px solid #8a7352;
  border-radius: 8px;
  background: linear-gradient(135deg, rgb(61 23 102) 0%, rgb(90 24 154) 50%, rgb(123 44 191) 100%);
  padding: 0 12px;
  box-shadow:
    0 0 14px rgba(123, 44, 191, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    0 2px 4px rgba(0, 0, 0, 0.25);
}

.total-page2 {
  background: linear-gradient(135deg, rgb(122 122 133) 0%, rgb(98 98 110) 50%, rgb(78 78 90) 100%);
  border-color: #6e6e7a;
  box-shadow:
    0 0 10px rgba(110, 110, 122, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.35),
    0 1px 3px rgba(0, 0, 0, 0.2);
}

.nickname {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 24px;
  font-weight: 600;
  font-style: italic;
  justify-content: space-between;
  color: #fff;
  text-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.3);
}

.total-inner {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 4px 0 0 4px;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.3);
  padding-left: 6px;
}

.carousel-indicators {
  width: 234px;
  position: absolute;
  bottom: 50px;
  right: 9%;
  transform: translateX(-50%);
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.carousel-indicators span {
  display: block;
  width: 48px;
  height: 48px;
  font-size: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(138 138 149) 0%, rgb(110 110 122) 100%);
  cursor: pointer;
  transition: all 0.3s;
  line-height: 48px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  border: 1px solid #6e6e7a;
  box-shadow:
    0 1px 4px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.carousel-indicators span.active {
  background: linear-gradient(135deg, rgb(61 23 102) 0%, rgb(90 24 154) 50%, rgb(123 44 191) 100%);
  border-color: #9a825f;
  box-shadow:
    0 0 12px rgba(123, 44, 191, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.25);
  transform: scale(1.05);
}

.pause-con {
  position: absolute;
  bottom: 190px;
  right: 15%;
  width: 110px;
  height: 50px;
  transform: translateX(-50%);
}

.pause-con > button {
  width: 100%;
  height: 100%;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, rgb(61 23 102) 0%, rgb(90 24 154) 50%, rgb(123 44 191) 100%);
  border: 2px solid #8a7352;
  border-radius: 8px;
  box-shadow:
    0 0 12px rgba(123, 44, 191, 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    0 2px 4px rgba(0, 0, 0, 0.25);
  transition: all 0.3s;
}

.pause-con > button:hover {
  transform: translateY(-1px);
  box-shadow:
    0 0 18px rgba(123, 44, 191, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    0 3px 6px rgba(0, 0, 0, 0.3);
}

.pause-con > button:active {
  transform: translateY(0);
  box-shadow:
    0 0 10px rgba(123, 44, 191, 0.26),
    inset 0 1px 0 rgba(255, 255, 255, 0.38),
    0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/page260622/page-tp-paiming4.vue